/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// import React, { useState } from "react";
import PropTypes from "prop-types";
import React from "react";
import {
  getDistanceMax,
  getDistanceMinPositive,
  getForceMax,
  getForceMinPositive
} from "../../store/data/cartesianData";
import DeleteCross from "../../../Common/components/Icons/DeleteCross/DeleteCross";
import InputPlaceHolder from "../../../Common/components/Inputs/InputPlaceHolder/InputPlaceHolder";
import "./ForcesParametersRows.scss";

const FORCE_MAX = getForceMax();
const FORCE_MIN_POSITIVE = getForceMinPositive();
const FORCE_TOOLTIP = `The value should be between ${FORCE_MIN_POSITIVE} and ${FORCE_MAX}.`;

const DISTANCE_MAX = getDistanceMax();
const DISTANCE_MIN_POSITIVE = getDistanceMinPositive();
const DISTANCE_TOOLTIP = `The value should be between ${DISTANCE_MIN_POSITIVE} and ${DISTANCE_MAX}.`;

const ForceParameterCheckSection = ({ index, enable, onValUpdate, ...props }) => (
  <div className="ForceParameterCheckSection blue fp-customcb flex">
    <input
      type="checkbox"
      id={`fp${index}`}
      name="enable"
      checked={enable}
      onChange={(event) => onValUpdate(index, event)}
      {...props}
    />
    <label className="innerfp" for={`fp${index}`} />
  </div>
);

const ForcesParametersRows = ({
  rows,
  tableRowRemove,
  onValUpdate,
  handleInputFocusIn,
  handleInputFocusOut,
  indexSelected,
  ...props
}) =>
  rows.map((rowsData, index) => {
    let { title, fx, fy, fz, dx, dy, dz } = rowsData;
    const enable = index === indexSelected;
    title = title === undefined ? "" : title;
    fx = fx === undefined ? "" : fx;
    fy = fy === undefined ? "" : fy;
    fz = fz === undefined ? "" : fz;
    dx = dx === undefined ? "" : dx;
    dy = dy === undefined ? "" : dy;
    dz = dz === undefined ? "" : dz;
    return (
      <div
        className="ForcesParametersRows fp-flex-table fp-row-padding fp-table-border-right fp-table-border-left"
        role="rowgroup"
        id={`fpr-${index}`}
        {...props}
      >
        <div className="fp-flex-row-small first" role="cell">
          <ForceParameterCheckSection
            data-testid="force-parameter-check-section"
            index={index}
            enable={enable}
            onValUpdate={onValUpdate}
          />
        </div>
        <div className="fp-flex-row-large " role="cell">
          <InputPlaceHolder
            data-testid="input-place-holder-title"
            value={title}
            updateChanges={onValUpdate}
            index={index}
            name="title"
            selected={index === indexSelected}
            onfocusin={handleInputFocusIn}
            onfocusout={handleInputFocusOut}
            error={title === ""}
          />
        </div>
        <div className="fp-flex-row" role="cell">
          <InputPlaceHolder
            data-testid="input-place-holder-fx"
            value={fx}
            updateChanges={onValUpdate}
            index={index}
            unit="N"
            name="fx"
            selected={index === indexSelected}
            isNumber
            onfocusin={handleInputFocusIn}
            onfocusout={handleInputFocusOut}
            tooltip={FORCE_TOOLTIP}
            error={
              (fx === "" && (fy !== "" || fz !== "" || dx !== "" || dy !== "" || dz !== "")) ||
              fx < 0 ||
              (fx !== "" && !Number.isInteger(Number(fx))) ||
              Number(fx) + Number(fy) + Number(fz) === 0
            }
          />
        </div>
        <div className="fp-flex-row" role="cell">
          <InputPlaceHolder
            data-testid="input-place-holder-fy"
            value={fy}
            updateChanges={onValUpdate}
            index={index}
            unit="N"
            name="fy"
            selected={index === indexSelected}
            isNumber
            onfocusin={handleInputFocusIn}
            onfocusout={handleInputFocusOut}
            tooltip={FORCE_TOOLTIP}
            error={
              (fy === "" && (fz !== "" || fx !== "" || dx !== "" || dy !== "" || dz !== "")) ||
              fy < 0 ||
              (fy !== "" && !Number.isInteger(Number(fy))) ||
              Number(fx) + Number(fy) + Number(fz) === 0
            }
          />
        </div>
        <div className="fp-flex-row" role="cell">
          <InputPlaceHolder
            data-testid="input-place-holder-fz"
            value={fz}
            updateChanges={onValUpdate}
            index={index}
            unit="N"
            name="fz"
            selected={index === indexSelected}
            isNumber
            onfocusin={handleInputFocusIn}
            onfocusout={handleInputFocusOut}
            tooltip={FORCE_TOOLTIP}
            error={
              (fz === "" && (fy !== "" || fx !== "" || dx !== "" || dy !== "" || dz !== "")) ||
              fz < 0 ||
              (fz !== "" && !Number.isInteger(Number(fz))) ||
              Number(fx) + Number(fy) + Number(fz) === 0
            }
          />
        </div>
        <div className="fp-flex-row" role="cell">
          <InputPlaceHolder
            data-testid="input-place-holder-dx"
            value={dx}
            updateChanges={onValUpdate}
            index={index}
            unit="mm"
            name="dx"
            selected={index === indexSelected}
            isNumber
            onfocusin={handleInputFocusIn}
            onfocusout={handleInputFocusOut}
            tooltip={DISTANCE_TOOLTIP}
            error={
              (dx === "" && (dy !== "" || dz !== "" || fx !== "" || fy !== "" || fz !== "")) ||
              dx < 0 ||
              (dx !== "" && !Number.isInteger(Number(dx)))
            }
          />
        </div>
        <div className="fp-flex-row" role="cell">
          <InputPlaceHolder
            data-testid="input-place-holder-dy"
            value={dy}
            updateChanges={onValUpdate}
            index={index}
            unit="mm"
            name="dy"
            selected={index === indexSelected}
            isNumber
            onfocusin={handleInputFocusIn}
            onfocusout={handleInputFocusOut}
            tooltip={DISTANCE_TOOLTIP}
            //error={dy === "" || !Number.isInteger(Number(dy))}
            error={
              (dy === "" && (dx !== "" || dz !== "" || fx !== "" || fy !== "" || fz !== "")) ||
              dy < 0 ||
              (dy !== "" && !Number.isInteger(Number(dy)))
            }
          />
        </div>
        <div className="fp-flex-row" role="cell">
          <InputPlaceHolder
            data-testid="input-place-holder-dz"
            value={dz}
            updateChanges={onValUpdate}
            index={index}
            unit="mm"
            name="dz"
            selected={index === indexSelected}
            isNumber
            onfocusin={handleInputFocusIn}
            onfocusout={handleInputFocusOut}
            tooltip={DISTANCE_TOOLTIP}
            //error={dz === "" || !Number.isInteger(Number(dz))}
            error={
              (dz === "" && (dy !== "" || dx !== "" || fx !== "" || fy !== "" || fz !== "")) ||
              dz < 0 ||
              (dz !== "" && !Number.isInteger(Number(dz)))
            }
          />
        </div>
        <div className="fp-flex-row-small" role="cell">
          <DeleteCross tableRowRemove={tableRowRemove} index={index} showToolTip={false} data-testid="delete-cross" />
        </div>
      </div>
    );
  });
ForcesParametersRows.propTypes = {
  id: PropTypes.string
};

ForcesParametersRows.defaultProps = {
  id: null
};
export default ForcesParametersRows;
